import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import styled from '@emotion/styled';
import { LinkStyle } from './style';
import { menuItems } from '../../utils/constant';
import { logout } from '../../redux/globalAction';
import useFilteredMenuItems from '../../hooks/useFilteredMenuItems';
import { checkActiveTab } from '../../utils/common_functions';
import { logoutUrl } from '../../redux/sign-in/apiRoute';
import TableLoader from '../loaders/TableLoader';

function MenuDrawer() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [selectedMenu, setSelectedMenu] = useState('');
  const [logoutLoading, setLogoutLoading] = useState(false);

  const { user_details, permissions, isEmployee, userInfo } = useSelector((state) => ({
    user_details: state?.userInfo?.data?.user_details,
    permissions: state?.userInfo?.data?.permissions,
    isEmployee: state?.userInfo?.isEmployee,
    userInfo: state?.userInfo
  }));

  const filteredMenuItems = useFilteredMenuItems(permissions, isEmployee, menuItems);

  const handleLogout = async () => {
    setLogoutLoading(true);
    try {
      let res = await logoutUrl({
        deviceId: userInfo?.deviceId
      });

      if (res?.statusCode === 200) {
        dispatch(logout());
        toast.success('Logout Successfully');
        navigate('/');
      } else {
        toast.error(res?.message);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      setLogoutLoading(false);
    }
  };

  useEffect(() => {
    const activeTab = checkActiveTab(location.pathname);
    setSelectedMenu(activeTab);
  }, [location]);

  return (
    <MenuWrapper>
      <NavWrapper>
        {filteredMenuItems?.map((list) => (
          <MenuList key={list?.id} checked={selectedMenu === list?.name}>
            <LinkStyle to={list.path} state={{ id: user_details?.id }}>
              {list?.icon}
              {list?.name}
            </LinkStyle>
          </MenuList>
        ))}
      </NavWrapper>
      <HeaderSection>
        <div onClick={handleLogout} className="logout">
          {logoutLoading && <TableLoader size="15px" color="#fff" />} Logout
        </div>
      </HeaderSection>
    </MenuWrapper>
  );
}

export default MenuDrawer;
const MenuWrapper = styled.div`
  padding: 20px 20px 0;
  height: 100%;
`;

const MenuList = styled.div`
  color: ${(props) => (props.checked ? props.theme.primaryColor : `#818b9a`)};
  font-size: 18px;
  font-weight: 500;
  padding: 0 0 20px;

  svg path {
    fill: ${(props) => (props.checked ? props.theme.primaryColor : `#818b9a`)};
    transition: fill 0.3s ease;
  }

  a {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;

    &:hover {
      color: ${(props) => props.theme.primaryColor};

      svg path {
        fill: ${(props) => props.theme.primaryColor};
      }
    }
  }
`;

const HeaderSection = styled.div`
  display: flex;
  padding: 5px 0px;
  justify-content: space-between;
  padding: 20px 0;
  border-top: 1px solid grey;
  font-weight: 600;
  .logout {
    width: 100%;
    height: 42px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 8px;
    color: #ffffffff;
    border: 1px solid #e53935;
    border-radius: 6px;
    font-weight: 600;
    font-size: 14px;
    background-color: transparent;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    /* background: radial-gradient(#ffffff, transparent); */
    /* background: radial-gradient(#ffffff, transparent); */
    background: #e23b30;
    &:hover {
      background-color: #dd1714ff;
    }

    svg {
      fill: currentColor;
      transition: fill 0.3s ease;
    }
  }
`;

const NavWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  justify-content: start;
  height: calc(100vh - 160px);
  overflow: auto;

  &::-webkit-scrollbar {
    width: 0px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  &::-webkit-scrollbar-thumb {
    background: #888;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;
